"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trim = void 0;
const rtrim_1 = require("./rtrim");
const ltrim_1 = require("./ltrim");
function trim(str, chars) {
    return (0, rtrim_1.rtrim)((0, ltrim_1.ltrim)(str, chars), chars);
}
exports.trim = trim;
